// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__CSj98","col":"CardReaderDesc_col__tmT_V","label":"CardReaderDesc_label__1yqZo"};